import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material'
import 'dayjs/locale/es'
import TeamCalendarDates from '../components/TeamCalendarDates'
import TeamCalendarHeader from '../components/TeamCalendarHeader'

const TeamCalendarAccordeon = ({ team, year, month }) => {
  return team?.map((group, i) => (
    <Accordion defaultExpanded key={`team-acc-${i}`}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`group${i}-content`}
        id={`group${i}-header`}
        key={`group${i}-header`}
      >
        {group.name}
      </AccordionSummary>
      <AccordionDetails>
        {group.subteams.map((subteam, k) => {
          return (
            <Box key={`sub_group_${k}`}>
              {subteam.name && subteam.name !== 'NO_SUBTEAM' ? (
                <Accordion defaultExpanded key={`subteam-acc-${k}`}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`subgroup${i}-content`}
                    id={`subgroup${i}-header`}
                  >
                    {subteam.name}
                  </AccordionSummary>
                  <AccordionDetails>
                    <TeamCalendarHeader key={'cal_head'} year={year} month={month} />
                    {subteam.employees.map((e, j) => {
                      return <TeamCalendarDates key={`sub_dat_${j}`} employee={e} />
                    })}
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Box>
                  <TeamCalendarHeader key={'cal_head'} year={year} month={month} />
                  {subteam.employees.map((e, j) => {
                    return <TeamCalendarDates key={`sub_dat_${j}`} employee={e} />
                  })}
                </Box>
              )}
            </Box>
          )
        })}
      </AccordionDetails>
    </Accordion>
  ))
}

export default TeamCalendarAccordeon
